module.exports = __webpack_public_path__ + "img/classical_conditoning_trigger.f211b0c9.jpg";